import { defineComponent as _defineComponent } from 'vue'
import BCXSkeleton from '@/components/molecules/BCXSkeleton.vue';
import ThreadMessageSkeleton from '@/views/forum/components/ThreadMessageSkeleton.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ThreadRepliesSkeleton',
  setup(__props) {


return { __sfc: true,BCXSkeleton, ThreadMessageSkeleton }
}

})